
export const MaintenanceModeTicker = () => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'orange',
    color: 'white',
    textAlign: 'center',
    padding: '10px',
    zIndex: 1000 // Ensure it overlays on top of other components
  }}>
    Maintenance Mode Activate - Missions Disabled and Functionality Limited
  </div>
);
